export default __webpack_public_path__ + "static/media/39.0c184bb9.jpg";